import { getItem } from "../utils/authStorage";
import { parseJwt } from "../utils/jwtDecoder";

export function useAuth() {
  const token = getItem("accessToken");
  const tokenPayload = token ? parseJwt(token) : null;
  const username =
    getItem("username") ||
    tokenPayload?.username ||
    tokenPayload?.preferred_username ||
    "User";
  const rawRole =
    getItem("role") || tokenPayload?.role || tokenPayload?.roles?.[0] || "Operator";
  const role = rawRole.toLowerCase();

  return { username, role, token, tokenPayload };
}
